export default "__VITE_ASSET__BHIclfvW__"